import React, { useState, useEffect, Fragment } from 'react';
import { useSelector } from "react-redux";
import { Menu, Transition } from '@headlessui/react';
import clsx from 'clsx';

const LanguageSelector = ({mobile}) => {
    const languages = useSelector((state) => state.navigation.languages);

    if(languages.length < 2){
        return null;
    }

    const selectedLanguage = languages.find(x => x.selected);

    return (<div className="language-selector__wrapper">
        <Menu as="div" className="language-selector__menu">
            {({ open }) => (
                <>
                    <div>
                        <Menu.Button className={clsx("language-selector__button", mobile && "language-selector__button--mobile")}>
                            {selectedLanguage.text}
                            <svg className={"language-selector__arrow" + (open ? " language-selector__arrow--open" : "")}
                                 width="20" height="21" viewBox="0 0 20 21" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g id="chevron-down">
                                    <path id="Vector" d="M5 7.68945L10 12.6895L15 7.68945"
                                          stroke={mobile ? "var(--navigation-text, #fff)" : "var(--top-bar-text, #fff)"}
                                          strokeWidth="2"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                </g>
                            </svg>

                        </Menu.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        enter="language-selector__transition--enter"
                        enterFrom="language-selector__transition--enter-from"
                        enterTo="language-selector__transition--enter-to"
                        leave="language-selector__transition--leave"
                        leaveFrom="language-selector__transition--leave-from"
                        leaveTo="language-selector__transition--leave-to"
                    >
                        <Menu.Items className="language-selector__items">
                            <div className="language-selector__items-content">
                                {languages.map((x, index) => (
                                    <Menu.Item key={index}>
                                        {({ active }) => (
                                            <a
                                                href={x.value}
                                                className={`language-selector__item-button ${active ? 'language-selector__item-button--active' : ''}`}
                                            >
                                                {
                                                    x.imageUrl && <img src={x.imageUrl} alt="" width={18} height={18}/>
                                                }
                                                <span>{x.extendedText}</span>
                                            </a>
                                        )}
                                    </Menu.Item>
                                ))}
                            </div>
                        </Menu.Items>
                    </Transition>
                </>
            )}
        </Menu>
    </div>)
}

export default LanguageSelector;
